// export default {
//   install(app) {
//     // Charger le SDK Axeptio
//     const script = document.createElement("script");
//     script.src = "https://static.axept.io/sdk.js";
//     script.async = true;

//     window.axeptioSettings = {
//       clientId: "64818c6f0bc843157eec3fb7",
//       cookiesVersion: "sobeautifulbysarah-fr",
//       onAccept(cookies) {
//         console.log("zzzzzzzzz", cookies)
//         if (cookies.google_analytics) {
//           // Charger Google Analytics uniquement si consentement
//           (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
//           (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
//           m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
//           })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
//           ga('create', 'UA-143011546-1', 'auto');
//           ga('send', 'pageview');
//           console.log("Google Analytics chargé");
//         }
//       },
//     };

//     document.body.appendChild(script);
//     console.log("Axeptio script ajouté");
//   },
// };

export default {
  install(app) {
    window.axeptioSettings = {
        clientId: "64818c6f0bc843157eec3fb7",
        cookiesVersion: "sobeautifulbysarah-fr",
        googleConsentMode: {
            default: {
            analytics_storage: "denied",
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            wait_for_update: 500
            }
        },
        onAccept: (cookies) => {
            console.log("Cookies acceptés :", cookies);
            if (cookies.google_analytics) {
                // Exemple pour GA4 ou GTM
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-XXXXXX');
                console.log("Google Tag Manager chargé");
            }
        },
    };

    const script = document.createElement("script");
    script.src = "https://static.axept.io/sdk.js?v=2";
    script.async = true;
    script.onload = () => console.log("Axeptio SDK chargé");
    script.onerror = () => console.error("Erreur de chargement du SDK Axeptio");
    document.body.appendChild(script);
  },
};